import { useEffect, useState } from "react";
import * as streamreportService from "../../../services/streamReport.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomRangepicker from "../../../common/rangepicker";
import { Placeholder } from "rsuite";
import Sorting from "../../../common/sorting";
import { formateDateWithMonthAdmin } from "../../../../../utils/commonfunction";
import CustomPagination from "../../../common/custompagination";
import Breadcrums from "../../../common/breadcrumbs";
import StreamChart from "./streamChart";

const StreamReportList = () => {
    const [list, setList] = useState([]);
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(false);
    const [globalsearch, setGlobalSearch] = useState("");
    const [sorting, setSorting] = useState({});
    const [filter, setFilter] = useState("30");
    const [resetdate, setResetDate] = useState(false);
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [statsupdate, setStatsUpdate] = useState("false");
    const [itemperpage] = useState(10);
    const [datalength, setDataLength] = useState(0);
    const [page, setPage] = useState(1);
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Stream Report"), url: "" },
    ];

    // Function to fetch data
    const fetchData = () => {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("global_search", globalsearch);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        streamreportService.List(formData)
            .then((response) => {
                console.log("response", response);
                console.log("Response data:", response.data); // <- should have list & total_records

                setDataLength(response.data?.total_records || 0);
                setList(response.data?.list || []);
                setPage(response.data?.page || 1);
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching stream reports:", error);
                setLoader(false);
            });
    };

    // ─── UseEffect with debounce ────────────────────────────────
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchData();
        }, 300);

        return () => clearTimeout(timer);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    // ─── Search / Filter Helpers ─────────────────────────────────────────────────
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        setSearch({});
        setResetDate(!resetdate);
        setDefaultSorting(true);
        setSorting({});
    };

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div style={{
                    display: "flex",
                }}>
                    <div className="mb-4 flex items-center space-x-2">
                        <label className="mr-2 font-medium text-gray-700">Select Duration:</label>
                        <select
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            className="px-4 py-2 rounded-xl cp border border-gray-300 bg-white shadow-md text-gray-700 
                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
                transition duration-200 ease-in-out hover:border-indigo-400"
                        >
                            <option value="7">Last 7 Days</option>
                            <option value="30">Last 30 Days</option>
                            <option value="90">Last 90 Days</option>
                            <option value="all">All</option>
                        </select>
                    </div>

                </div>
                <StreamChart filter={filter} From="StreamReport" />

                {/* Table Card */}
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">
                                {t("Stream Report")}
                            </h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => setGlobalSearch(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => prepareSearch("createdAt", e)}
                                        resetdate={resetdate}
                                    />
                                </div>
                                <button
                                    type="reset"
                                    value="Reset"
                                    onClick={resetFilter}
                                    className="btn btn-warning float-right mr-2"
                                >
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>

                        {loader ? (
                            <Placeholder.Paragraph
                                className="w-100"
                                rowHeight={30}
                                rowSpacing={5}
                                active={true}
                                rows={7}
                            />
                        ) : (
                            <>
                                <div className="table-responsive min-h-400">
                                    <table className="table table-bordered border-t0 card-table border-top text-nowrap w-100">
                                        <thead>
                                            <tr>
                                                <th className="position-relative select_head">
                                                    <span>{t("list_heading_sno")}</span>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("label_title")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="title"
                                                        />
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("Creator")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="seller_name"
                                                        />
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("label_total_comments")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="total_comments"
                                                        />
                                                    </div>
                                                </th>
                                                <th className="status_head">
                                                    <div className="sorting_column">
                                                        <span>{t("total view")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="total_views"
                                                        />
                                                    </div>
                                                </th>
                                                <th className="status_head">
                                                    <div className="sorting_column">
                                                        <span>{t("total_likes")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="total_likes"
                                                        />
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("Total Flags")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="total_flags"
                                                        />
                                                    </div>
                                                </th>
                                                <th><span>{t("Type")}</span></th>
                                                <th><span>{t("Duration (s)")}</span></th>
                                                <th><span>{t("FB Views")}</span></th>
                                                <th><span>{t("YT Views")}</span></th>
                                                <th><span>{t("Twitch Views")}</span></th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("Accepted Products")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="accepted_products"
                                                        />
                                                    </div>
                                                </th>
                                                <th className="created_head">
                                                    <div className="sorting_column">
                                                        <span>{t("list_heading_created_date")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            defaultSorting={defaultSorting}
                                                            column="createdAt"
                                                        />
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.length ? (
                                                list.map((row, i) => (
                                                    <tr key={row._id || i}>
                                                        <td>{(page - 1) * itemperpage + i + 1}</td>
                                                        <td>{row?.title ? row?.title : "N/A"}</td>
                                                        <td>{row?.seller_name || row?.seller_email || "N/A"}</td>
                                                        <td>{row?.total_comments ?? 0}</td>
                                                        <td>{row?.total_views ?? 0}</td>
                                                        <td>{row?.total_likes ?? 0}</td>
                                                        <td>{row?.total_flags ?? 0}</td>
                                                        <td>{row?.stream_type ? (row.stream_type === "LIVE" ? "Live" : "Pre-recorded") : "N/A"}</td>
                                                        <td>{row?.duration ?? 0}</td>
                                                        <td>{row?.fb_views ?? 0}</td>
                                                        <td>{row?.yt_views ?? 0}</td>
                                                        <td>{row?.twitch_views ?? 0}</td>
                                                        <td>{row?.accepted_products ?? 0}</td>
                                                        <td>
                                                            {row?.createdAt
                                                                ? formateDateWithMonthAdmin(row.createdAt)
                                                                : "N/A"}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={14} className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="" id="example1_info" role="status" aria-live="polite">
                                    <b>{t("msg_total_records")} : {datalength || "0"}</b>
                                </div>
                                {datalength > 0 && (
                                    <CustomPagination
                                        datalength={datalength}
                                        itemperpage={itemperpage}
                                        currentPage={page}
                                        setPage={setPage}
                                        pageRoute={[
                                            {
                                                name: "",
                                                path: "/admin/reports/stream/list",
                                            },
                                        ]}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default StreamReportList;